import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    formParams: {} as { formData: any, rutaForm: any, rutaView: any, title: any, controlador: any, permisoAdd: any, permisoEdit: any, permisoDelete: any, permisoSincronizacion: any, modo: any}
  },
  mutations: {
    setFormParams(state, payload){
      state.formParams=payload;
    },
    getFormParams(state){
      return state.formParams
    },
  },
  actions: {
    actionsetFormParams({commit}, per){
      commit('setFormParams', per)
    },
    actionGetFormParams({commit}){
      commit('getFormParams')
    },
  },
})
